import { Fragment } from 'react';

import ClientApp from '~/ClientApp';
import ClientRouter from '~/ClientRouter';
import { ExpertAdviceForSRP } from '~/pages/couples/explore/components/ExpertAdvice/ExpertAdviceForSrp';
import { AdjacentVendors } from '~/pages/couples/explore/components/SearchResults/components/AdjacentVendors/AdjacentVendors';
import { RealWeddings } from '~/pages/couples/explore/components/SearchResults/components/RealWeddings/RealWeddings';
import { SearchResultsPageBreadcrumbs } from '~/pages/couples/explore/components/SearchResults/components/SearchBreadcrumb/SearchBreadcrumb';
import { SearchResultsHead } from '~/pages/couples/explore/components/SearchResults/components/SearchResultsHead/SearchResultsHead';
import { SeoContentBlock } from '~/pages/couples/explore/components/SearchResults/components/SeoContentBlock/SeoContentBlock';
import { VendorSearchNavigationProvider } from '~/pages/couples/explore/components/SearchResults/contexts/VendorSearchNavigationProvider';
import { SearchResultsContent } from '~/pages/couples/explore/components/SearchResults/SearchResultsContent';
import SearchResultsPageModalsAndToasts from '~/pages/couples/explore/SearchResultsPageModalsAndToasts';

import { SRPSearchBarProvider } from './components/SearchControls/SRPSearchBarContext';
import { TopPicksSection } from './components/TopPicks/TopPicksSection';

export const PostAuthSearchResultsPage = () => {
  return (
    <Fragment>
      <VendorSearchNavigationProvider>
        <SearchResultsHead />

        <TopPicksSection />
        <SearchResultsPageBreadcrumbs location="top" />

        <SRPSearchBarProvider>
          <SearchResultsContent />
        </SRPSearchBarProvider>
        <AdjacentVendors />
        <ExpertAdviceForSRP />

        <RealWeddings />
        <SeoContentBlock />
        <SearchResultsPageBreadcrumbs location="bottom" />
      </VendorSearchNavigationProvider>

      <ClientApp useStore={false}>
        <ClientRouter>
          <SearchResultsPageModalsAndToasts />
        </ClientRouter>
      </ClientApp>
    </Fragment>
  );
};
